import Link from '@mui/material/Link';

type SentryLinkProps = {
  userId?: string;
  companyId?: string;
};

export const SentryLink = ({ userId, companyId }: SentryLinkProps) => {
  const environment = import.meta.env.TREAD__ENV || 'staging';
  let queryParam = 'is:unresolved issue.priority:[high, medium]';
  if (userId) {
    queryParam += ` user.id:${userId}`;
  } else if (companyId) {
    queryParam += ` company_id:${companyId}`;
  }
  const sentryUrl = `https://tread.sentry.io/issues/?environment=${environment}&project=256719&sort=date&statsPeriod=30d&query=${encodeURIComponent(queryParam)}`;
  return (
    <Link
      href={sentryUrl}
      target="_blank"
      rel="noopener noreferrer"
      variant="caption"
      color="primary"
      sx={{ fontSize: '0.75rem' }}
    >
      Sentry
    </Link>
  );
};
